module.exports = __webpack_public_path__ + "img/bj44.f00c44bc.png";